import React from 'react';
import type { WidgetStrings } from '../../utils/i18n';
import { DEFAULT_WIDGET_STRINGS } from '../../utils/i18n';

interface TypingIndicatorProps {
  strings?: WidgetStrings;
  /**
   * When false, only the dots render: no sr-only text or label. MainContent turns
   * this off once a stream has started so "Agent is typing" is not repeated after
   * the streaming status region has already spoken for the turn.
   */
  announce?: boolean;
}

const TypingIndicator = React.memo(function TypingIndicator({
  strings = DEFAULT_WIDGET_STRINGS,
  announce = true,
}: TypingIndicatorProps) {
  return (
    // No role="status"/aria-live here: the parent message log is already a polite live
    // region, so the visually hidden text below is what gets announced.
    <div
      className="flex items-start mb-4"
      aria-label={announce ? strings.agentTypingAria : undefined}
      aria-hidden={announce ? undefined : true}
    >
      {announce && <span className="sr-only">{strings.agentTypingAria}</span>}
      <div className="max-w-[80%] rounded-lg px-3 py-2 bg-white border border-gray-200">
        <span className="typing-dot" aria-hidden="true" />
        <span className="typing-dot" aria-hidden="true" />
        <span className="typing-dot" aria-hidden="true" />
      </div>
    </div>
  );
});

export default TypingIndicator;
